<nb-layout>
  <nb-layout-column *ngIf="view !== 'on-deck'">
    <h1>Operations Board</h1>

    <h2>Latest Notifications</h2>
    <div class="row">
      <div class="col-xs-12">
        <nb-alert *ngFor="let update of notifications$ | async" status="primary">
          {{ update.message }}
          <small>
            {{ update.updatedAt.toDate() | date : 'short' }}
          </small>
        </nb-alert>
      </div>
    </div>

    <h2>Tasks</h2>
    <h6>Tasks Completion Stats</h6>
    <div class="row">
      <div class="col-xs-4 col-sm-2 text-center" *ngFor="let stat of completedStats | keyvalue">
        <nb-alert
          class="stat-card"
          status="info"
          (click)="viewCompletedTaskStats(stat.value, stat.key, taskListDialog)"
        >
          <span class="margin" style="font-size: 3em">{{ stat.value.length }}</span>
          <span>{{ stat.key }}</span>
        </nb-alert>
      </div>
    </div>
    <h6>Open Tasks</h6>
    <p *ngIf="pendingCount < 1">No Pending Tasks. Check with the office for new tasks.</p>
    <div class="row">
      <div class="col-xs-12 col-sm-6" *ngFor="let update of tasks$ | async">
        <nb-card>
          <nb-card-body>
            <nb-tag
              size="tiny"
              [status]="update.status === 'completed' ? 'success' : 'warning'"
              [text]="update.status"
            ></nb-tag>
            <nb-tag
              *ngIf="update.status === 'completed'"
              size="tiny"
              status="info"
              [text]="'Completed By: ' + update.assignee"
            >
            </nb-tag>
            <br />
            <p>{{ update.message }}</p>
          </nb-card-body>
          <nb-card-footer>
            <button
              *ngIf="update.status !== 'completed'"
              status="success"
              nbButton
              size="tiny"
              (click)="completeTask(dialogConfirm, update)"
            >
              Mark Complete
            </button>
            <small style="float: inline-end">
              Posted On: {{ update.createdAt?.toDate() | date }} | Last Updated:
              {{ update.updatedAt?.toDate() | date }}
            </small>
          </nb-card-footer>
        </nb-card>
      </div>
    </div>

    <ng-template #dialogConfirm let-data let-ref="dialogRef">
      <nb-card size="small">
        <nb-card-header>Confirm Completion</nb-card-header>
        <nb-card-body>
          <p>I confirm that I have completed this task</p>

          <input
            [(ngModel)]="taskAssignee"
            (keyup)="taskAssignee = taskAssignee.toUpperCase()"
            type="text"
            nbInput
            fullWidth
            fieldSize="small"
            placeholder="Enter your initials"
          />
        </nb-card-body>
        <nb-card-footer>
          <button
            [disabled]="!taskAssignee || taskAssignee.length < 2"
            class="margin"
            nbButton
            status="success"
            (click)="ref.close(true)"
          >
            I Agree
          </button>
          <button class="margin" nbButton (click)="ref.close(false)">Cancel</button>
        </nb-card-footer>
      </nb-card>
    </ng-template>
    <ng-template #taskListDialog let-data let-ref="dialogRef">
      <nb-card size="large">
        <nb-card-header>Completed Tasks - {{ data.person }}</nb-card-header>
        <nb-card-body>
          <div class="row" *ngFor="let item of data.taskList">
            <div class="col-xs-12">
              <nb-tag size="tiny" text="{{ item.updatedAt.toDate() | date : 'short' }}"></nb-tag>
              {{ item.message }}
            </div>
          </div>
        </nb-card-body>
        <nb-card-footer>
          <button style="float: right" nbButton status="primary" (click)="ref.close()">Okay</button>
        </nb-card-footer>
      </nb-card>
    </ng-template>
  </nb-layout-column>
  <nb-layout-column
    class="page-container"
    [ngClass]="currentAnimationClass"
    *ngIf="view === 'on-deck'"
  >
    <h1 class="text-banner no-margin padding">
      <nb-icon icon="list-outline"></nb-icon>
      On-Deck At Russell's
    </h1>
    <p class="text-center" *ngIf="pendingCount < 1">
      <nb-icon icon="done-all-outline"></nb-icon>
    </p>
    <p class="text-center" *ngIf="pendingCount < 1">
      No Pending Tasks. Check with the office for new tasks.
    </p>
    <div class="row">
      <div class="col-xs-12 no-padding">
        <ul>
          <li *ngFor="let update of tasks$ | async">
            <nb-alert class="text-task" accent="primary" status="basic">
              {{ update.message }}
            </nb-alert>
          </li>
        </ul>
      </div>
    </div>
    <div class="row" *ngIf="pendingCount > 0">
      <div class="col-xs-6 col-xs-offset-6 text-right">
        <small>
          This screen will display tasks and projects around the garden center that can be tackled
          during slower periods throughout the day. When you complete a task, please log it at the
          Information Station using the desktop icon labeled “On Deck.” Be sure to include your
          initials so we can track progress and participation. If you have any questions, see Mark
          or John K for more information.
        </small>
      </div>
    </div>
  </nb-layout-column>
  <nb-layout-column *ngIf="showScreensaver"> </nb-layout-column>
</nb-layout>
